import React from "react";
import { useState , useEffect } from "react";
import PageHeading from "../common/PageHeading";
import Slider from "react-slick";
import {
	ChevronLeft,
	ChevronRight,
	Facebook,
	Instagram,
	Phone,
	Whatsapp,
} from "../../utils/SvgComponents";
import "./OurFirms.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";
import CustomButton from "../common/button/Button";
import { apiHandler } from "../../utils/apiHandler";
import { useParams } from "react-router-dom";
import { EVENT_BASEURL } from "../../utils/Constants";

const resObj = {
	titleBg: "1699128296260-@-home_message.jpg",
	titleFg: "",
	firms: [
		{
			firmTitle: "Royal Handicrafts",
			firmSubtitle:
				"Manufacturing & Supplier of Wooden Handicrafts & Furniture Items",
			firmDescription:
				"We offer a wide range of handmade wooden products that are crafted by skilled artisans using traditional techniques and high-quality materials. Our products include furniture, decorative items, toys, and other household items that are designed to be both functional and aesthetically pleasing.",
			firmPhone: "",
			firmWA: "",
			firmFB: "",
			firmInsta: "",
			firmImg: "1699128350542-@-firm_1.jpg",
			_id: "65af7098b1ebca6d2d788607",
		},
		{
			firmTitle: "Jewel Exports Inc.",
			firmSubtitle:
				"Connecting global markets through expert sourcing, production, and logistics",
			firmDescription:
				"Our companies are involved in the sourcing, production, and distribution of goods for export.",
			firmPhone: "",
			firmWA: "",
			firmFB: "",
			firmInsta: "",
			firmImg: "1699128429433-@-firm_2.jpg",
			_id: "65af7098b1ebca6d2d788608",
		},
	],
	title: "Our Firms",
};

const OurFirms = () => {
	const { id } = useParams();
	const [res, setRes] = useState({});
	const [index, setIndex] = useState(0);
const [isBlurred, setIsBlurred] = useState(true);
			const [isImageLoaded, setIsImageLoaded] = useState(true);


	let NewUsername = "";

	const pathArray = window.location.pathname.split("/").filter(Boolean);

	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		NewUsername = pathArray[1];
	} else {
		NewUsername = pathArray[0]
	}

	let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
	const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
	console.log(newImgUrl);


	useEffect(() => {
		const fetchProfile = async () => {
			try {
				const res = await apiHandler.post("/guest/fetch-feature", {
					_id: id,
					category : "Firms"
				});
				console.log(res);
				if (res) {
					setRes(res);
				
				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};
		
		fetchProfile();
	},[])
	

useEffect(() => {
    // Unblur after 1 second (adjust delay as needed)
    const timer = setTimeout(() => {
      setIsBlurred(false);
    }, 200);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [res]);

	function SampleNextArrow(props) {
			const { className, style, onClick } = props;
			return (
				<div className={className} onClick={onClick}>
					<ChevronRight />
				</div>
			);
		}
	
		function SamplePrevArrow(props) {
			const { className, style, onClick } = props;
			return (
				<div className={className} onClick={onClick}>
					<ChevronLeft />
				</div>
			);
		}
	
		const settings = {
			afterChange: (i) => {
				setIndex(i);
			},
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			nextArrow: <SampleNextArrow />,
			prevArrow: <SamplePrevArrow />,
		};
	
		const mobileSliderSettings = {
			afterChange: (i) => {
				setIndex(i);
			},
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
		};
const formatPhone = (phone) => {
  if (!phone) return "";

  const cleaned = phone.replace(/\D/g, ""); // Remove non-digits

  // If it already starts with 91 and length is 12 → treat as full Indian number
  if (cleaned.startsWith("91") && cleaned.length === 12) return `+${cleaned}`;

  // If it starts with 0 → remove it and add +91
  if (cleaned.startsWith("0")) return `+91${cleaned.slice(1)}`;

  // If length is 10 → add +91
  if (cleaned.length === 10) return `+91${cleaned}`;

  // fallback
  return `+${cleaned}`;
};

	return (
		<div style={{zIndex:'333333',backgroundColor:'white'}}>
			<div className="hidden sm:block">
				<div className="grid grid-cols-12">
					<div className="col-span-5 h-screen w-full relative">
						<Swiper
							effect={"coverflow"}
							// grabCursor={true}
							slideToClickedSlide={true}
							longSwipes={false}
							shortSwipes={false}
							followFinger={false}
							loop={true}
							// height="100%"
							slidesPerView={1}
							freeMode={true}
							autoHeight={true}
							keyboard={true}
							navigation={{
								enabled: true,
								nextEl: "#custom-next-button",
								prevEl: "#custom-prev-button",
							}}
							pagination={{
								enabled: true,
								clickable: true,
								el: "#custom-pagination",
								type: "bullets",
							}}
							modules={[Navigation, Pagination]}
							className="mySwiper our-firms-main-slider"
							speed={500}
						>
							{res?.firms?.map((item) => (
								<SwiperSlide>
									<img
										src={`${newImgUrl+item.firmImg}`}
										alt=""
															onLoad={() => {
																setTimeout(() => {
										setIsImageLoaded(false)
									}, 300);
																
															}
															}
						  className={`h-full w-full transition-all duration-500 ${
                   (item && isImageLoaded) ? "blur-lg scale-105" : "blur-0 scale-100"
                }`}
									/>
									<div className="absolute left-0 bottom-0 w-full bg-[#0000009e] p-[12px]">
										<div className="flex justify-center items-center text-white text-3xl py-2 common-font tracking-[1.1px]">
											{item.firmTitle}
										</div>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
					<div className="col-span-7 p-[16px] h-screen flex flex-col overflow-x-auto">
						<div className="mx-auto">
							<PageHeading title={res.title} />
						</div>
					
						<div className="slider-container pc-slider flex-auto flex flex-col">
							
							<Swiper
								effect={"coverflow"}
								// grabCursor={true}
								// slideToClickedSlide={true}
								loop={true}
								slidesPerView={1}
								onRealIndexChange={(e) => setIndex(e.realIndex)}
								freeMode={true}
								longSwipes={false}
								shortSwipes={false}
								followFinger={false}
								autoHeight={true}
								keyboard={true}
								spaceBetween={"10px"}
								navigation={{
									enabled: true,
									nextEl: "#custom-next-button",
									prevEl: "#custom-prev-button",
								}}
								pagination={{
									enabled: true,
									clickable: true,
									el: "#custom-pagination",
									type: "bullets",
								}}
								modules={[Pagination, Navigation]}
								className="mySwiper our-firms-slider flex-auto"
								speed={500}
							>
								
								{res?.firms?.map((item) => (
									<SwiperSlide className="">
										<div
											key={item._id}
											className="text-center h-full flex flex-col justify-center black-color common-font "
										>
											<div className="text-[30px] font-semibold mx-28 tracking-[1px]">
												{item.firmSubtitle}
											</div>
											<div className="text-lg font-medium text-justify mx-20 mt-6 leading-[35px] tracking-[0.1px]">
												{item.firmDescription}
											</div>
											<div className="mt-7 flex justify-center items-center gap-10 ">
													{item?.firmPhone && <a href={`tel:${formatPhone(item.firmPhone)}`} className="flex flex-col justify-center items-center  cursor-pointer buttonripple no-underline">
														<Phone width="35"style={{ pointerEvents: 'none' }}  />
														<div className="text-lg font-medium text-black normal-case pointer-events-none">
															Phone 
														</div>
													</a>}
											

													{item?.firmWA && <a href={`https://wa.me/${item.firmWA}`}
														target="_blank"
														rel="noopener noreferrer"
														className="flex flex-col justify-center items-center   cursor-pointer buttonripple no-underline" >
														<Whatsapp width="35" style={{ pointerEvents: 'none' }} />
														<div className="text-lg font-medium text-black normal-case pointer-events-none">
															Whatsapp
														</div>
													</a>}

													{
														item?.firmInsta && <a href={item.firmInsta}
														target="_blank"
														rel="noopener noreferrer"
														className="flex flex-col justify-center items-center gap-1 cursor-pointer buttonripple no-underline">
														<Instagram width="35" style={{ pointerEvents: 'none' }}  />
														<div className="text-lg font-medium text-black normal-case pointer-events-none">
															Instagram
														</div>
													</a>
													}

													{item.firmFB!=='' && <a href={`${item.firmFB}`}
														target="_blank"
														rel="noopener noreferrer"
														className="flex flex-col justify-center items-center gap-1 cursor-pointer buttonripple no-underline">
														<Facebook width="35" style={{ pointerEvents: 'none' }} />
														<div className="text-lg font-medium text-black normal-case pointer-events-none">
															Facebook
														</div>
													</a>}
					
											</div>
											
										</div>
										
									</SwiperSlide>
								))}
							</Swiper>
							<div className="flex justify-center items-center gap-6 pb-10 ">
								<div id="custom-prev-button">
									<div
										bgColor="black"
										borderRadius="100%"
										paddingX="10px"
										paddingY="10px"
										className="bg-black rounded-full p-[10px] cursor-pointer whiteripple"
										clicked={() => {}}
									>
										<ChevronLeft fill="white" width="25" />
									</div>
								</div>
								<div
									id="custom-pagination"
									className="w-auto"
								></div>
								<button id="custom-next-button">
									<div
										bgColor="black"
										borderRadius="100%"
										paddingX="10px"
										paddingY="10px"
										className="bg-black rounded-full p-[10px] cursor-pointer whiteripple"
										clicked={() => {}}
									>
										<ChevronRight fill="white" width="25" />
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			{
				res?.firms && <div className="flex flex-col h-svh sm:hidden mobile-slider relative">
				<Swiper
					grabCursor={true}
					slideToClickedSlide={true}
					loop={true}
					slidesPerView={1}
					onRealIndexChange={(e) => setIndex(e.realIndex)}
					freeMode={true}
					updateOnWindowResize={true}
					autoHeight={true}
					keyboard={true}
					navigation={{
						enabled: true,
						nextEl: "#custom-next-button",
						prevEl: "#custom-prev-button",
					}}
					pagination={{
						enabled: true,
						clickable: true,
						el: "#custom-mobile-pagination",
						type: "bullets",
					}}
					modules={[Pagination, Navigation]}
					className="mySwiper our-firms--mobile-slider flex-auto"
					speed={500}
				>
					{res?.firms?.map((item, i) => (
						<SwiperSlide>
							<div
								key={item._id}
								className="h-full text-center flex flex-col"
							>
								<div
									className="flex-auto bg-center"
									style={{
        backgroundImage: `url(${newImgUrl + item.firmImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        filter: isBlurred ? "blur(10px)" : "none",
        transition: "filter 1s ease-in-out", // smooth unblur
        width: "100%",
        height: "400px", // set your preferred height
      }}
								>
									<div className="h-full flex flex-col">
										<div className="grow">
											<div className="flex justify-between items-center h-full mx-3">
												<div id="custom-prev-button">
													{i !== 0 && (
														<div className="bg-black/50 rounded-full overflow-hidden">
															<CustomButton
																clicked={() => {}}
															>
																<div className="p-3">
																	<ChevronLeft
																		width="25"
																		fill="white"
																	/>
																</div>
															</CustomButton>
														</div>
													)}
												</div>
												<div id="custom-next-button">
													{i !==
														res.firms.length -
															1 && (
														<div className="bg-black/50 rounded-full overflow-hidden whiteripple">
															<CustomButton
																clicked={() => {}}
															>
																<div className="p-3">
																	<ChevronRight
																		width="25"
																		fill="white"
																	/>
																</div>
															</CustomButton>
														</div>
													)}
												</div>
											</div>
										</div>
										<div className="">
											<div className="w-full py-[15px] text-white text-2xl font-semibold bg-black/50">
												{item.firmTitle}
											</div>
										</div>
									</div>
								</div>
								<div className="">
									<div className="flex flex-col justify-end h-full">
										<div className="text-black text-lg font-bold p-[15px]">
											{item.firmSubtitle}
										</div>
										<div className="border-t border-b text-justify border-black p-[15px] font-medium">
											{item.firmDescription}
										</div>
										<div className="flex items-center text-center gap-6 justify-center " >
  {item?.firmPhone && (
    <a
      href={`tel:${formatPhone(item.firmPhone)}`}
      className="buttonripple no-underline text-black"
    >
      <div className="flex flex-col justify-center items-center my-[15px]">
        <Phone width="30" />
        Phone
      </div>
    </a>
  )}

  {item?.firmWA && (
    <a
      href={`https://wa.me/${item.firmWA}`}
      target="_blank"
      rel="noopener noreferrer"
      className="buttonripple no-underline text-black"
    >
      <div className="flex flex-col justify-center items-center my-[15px]">
        <Whatsapp width="30" />
        Whatsapp
      </div>
    </a>
  )}

  {item?.firmInsta && (
    <a
      href={item.firmInsta}
      target="_blank"
      rel="noopener noreferrer"
      className="buttonripple no-underline text-black"
    >
      <div className="flex flex-col justify-center items-center my-[15px]">
        <Instagram width="30" />
        Instagram
      </div>
    </a>
  )}

  {item?.firmFB && (
    <a
      href={item.firmFB}
      target="_blank"
      rel="noopener noreferrer"
      className="buttonripple no-underline text-black"
    >
      <div className="flex flex-col justify-center items-center my-[15px]" >
        <Facebook width="30" />
        Facebook
      </div>
    </a>
  )}
</div>

									</div>
								</div>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
				{/* <div className="flex justify-between items-center "></div> */}
				<div
					id="custom-mobile-pagination"
					className="bg-gray-100 flex justify-center items-center gap-2 py-3"
				></div>
			</div>
			}
		</div>
	);
};

export default OurFirms;
